const environment = {
    compiled: true
}; // Nothing to override in prod

export default environment;
